import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useApiBaseUrl } from '../context/ApiContext';



const NewOrder = ({selectedCustomerId, onClose, handleSetNewOrderId}) => {
  const ApiBaseUrl = useApiBaseUrl();
  const [customerPONumber, setCustomerPONumber] = useState('');
  const [shippingInfo, setShippingInfo] = useState('');
  const [requestedShipDate, setRequestedShipDate] = useState(new Date());
  const [freightArrangedByDUSA, setFreightArrangedByDUSA] = useState('');
  const [ShipmentData, setShipmentData] = useState(null);
  const [selectedShippingAgentCode, setSelectedShippingAgentCode] = useState(null);
  const [selectedShipToCode, setSelectedShipToCode] = useState(null);
  const [selectedLocationCode, setSelectedLocationCode] = useState(null);
  //const [startingRequestedShipDate, setStartingRequestedShipDate] = useState();
  const [startingNewOrder, setStartingNewOrder] = useState(false);
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   // Handle form submission logic here
  //   console.log('Form submitted', { customerPONumber, shippingInfo, requestedShipDate, freightArrangedByDUSA });
  // };

  const [OrderCycleInfo, setOrderCycleInfo] = useState(null);

  useEffect(() => {
    const fetchOrderCycleInfo = async () => {
      try {
        const response = await fetch(`${ApiBaseUrl}/api/Sales/GetOrderCycleInfo`);
        const data = await response.json();
        setOrderCycleInfo(data);
        console.log('OrderCycleInfo retrieved from GetOrderCycleInfo:', data);
        setRequestedShipDate(new Date(data.minShipDate));
      } catch (error) {
        console.error('Error fetching order cycle info:', error);
      }
    };

    fetchOrderCycleInfo();
  }, []);

   useEffect(() => {
    const fetchShipmentData = async () => {
      try {
        const response = await fetch(`${ApiBaseUrl}/api/Sales/${selectedCustomerId}/GetShipmentInfoCustomers_ByEmail`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setShipmentData(data);
        console.log('Shipment data retrieved from GetShipmentInfoCustomers_ByEmail:', data);
      } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
      }
    };

    fetchShipmentData();
  }, []);

  const handleCreateNewOrder = () => {
    // console.log('Creating new order', { customerPONumber, shippingInfo, requestedShipDate, selectedLocationCode,
    //   'freightArrangedByDUSA_original': freightArrangedByDUSA,
    //    freightArrangedByDUSA: freightArrangedByDUSA === '' ? '' : freightArrangedByDUSA === 'true',
    //    shippingAgentCode: freightArrangedByDUSA === '' ? '' : freightArrangedByDUSA === 'true' ? selectedShippingAgentCode : 'DIST',
    //    selectedShipToCode });
    // //selectedShipmentData
    // console.log('selectedShippingAgentCode:', freightArrangedByDUSA === "true" ? selectedShippingAgentCode : 'DIST' );
    // console.log('selectedShipToCode:', selectedShipToCode);
    setStartingNewOrder(true);

    const orderData = {
      Klant: selectedCustomerId,
      CustomerPO: customerPONumber,
      DuvelArrangesFreight: freightArrangedByDUSA === 'true',
      ShippingAgentCode: freightArrangedByDUSA === 'true' ? selectedShippingAgentCode : 'DIST',
      LocationCode: selectedLocationCode,
      ExpectedShipDate: requestedShipDate,
      OrderCycle: '',
      CreatedBy: '',
      ShipToCode: selectedShipToCode
    };
  
    console.log('Creating new order', orderData);
    createNewOrder(orderData);
  };

  const createNewOrder = async (orderData) => {
    try {
      const response = await fetch(`${ApiBaseUrl}/api/Sales/${selectedCustomerId}/CreateNewOrder`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(orderData),
      });
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const data = await response.json();
      console.log('New order created:', data);
      handleSetNewOrderId(data);
      return data;
    } catch (error) {
      console.error('There was a problem with the create order operation:', error);
      throw error;
    }
  };


  const handleSelectedShippingInfo = (e) => {
    console.log('Selected shipping info:', e.target.value);
    var selectedShippingAgentCode = e.target.value.split('_')[1];
    setSelectedShippingAgentCode(selectedShippingAgentCode);
    var selectedShipToCode = e.target.value.split('_')[0];
    setSelectedShipToCode(selectedShipToCode);
    var selectedLocationCode = e.target.value.split('_')[2];
    setSelectedLocationCode(selectedLocationCode);
  };

  const handleFreightChange = (e) => {
    setFreightArrangedByDUSA(e.target.value);
  };
  

  return (
    <div className="new-order-form" style={{ backgroundColor: '#c41e3a', color: 'white', padding: '20px', maxWidth: '700px', margin: 'auto', position: 'absolute', zIndex: '9999', marginLeft: '30%', top: '256px', boxShadow: 'black 10px 10px 24px -8px' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px', color: 'white' }}>NEW ORDER</h2>
      <>
        <div className="form-group" style={{ marginBottom: '15px' }}>
          <label>Customer PO Number</label>
          <input
            type="text"
            value={customerPONumber}
            onChange={(e) => setCustomerPONumber(e.target.value)}
            style={{ width: '98%', padding: '5px' }}
          />
        </div>
        
        <div className="form-group" style={{ marginBottom: '15px' }}>
          <label>Shipping info:</label>
          <select
            onChange={handleSelectedShippingInfo}
            style={{ width: '100%', padding: '5px' }}
          >
            <option value=""></option>
            {ShipmentData ? (
              ShipmentData.map((item, index) => (
                <option key={index} value={item.shipToCode + '_' + item.shippingAgentCode + '_' + item.locationCode}>
                  {`SHIP TO: (${item.shippingAgentCode}) ${item.shipToAddress}, ${item.shipToAddress2 ? item.shipToAddress2 + ', ' : ''}${item.shipToCity}, ${item.shipToState} ${item.shipToPostcode} FROM ${item.locationCode} ${item.locationName}`}
                </option>
              ))
              ) : (
              <option>Loading shipment data...</option>
            )}
          </select>
        </div>
        
        <div className="form-group" style={{ marginBottom: '15px' }}>
          <label>Requested Ship Date</label>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            {/* <DatePicker
              selected={requestedShipDate}
              onChange={(date) => setRequestedShipDate(date)}
              dateFormat="MM/dd/yyyy"
              style={{ width: '100%', padding: '5px', display: 'block' }}
            /> */}
            <DatePicker
              selected={requestedShipDate}
              onChange={(date) => setRequestedShipDate(date)}
              dateFormat="MM/dd/yyyy"
              style={{ width: '100%', padding: '5px', display: 'block' }}
              filterDate={(date) => {
                const minDate = new Date(OrderCycleInfo.minShipDate);
                const maxDate = new Date(OrderCycleInfo.maxShipDate);
                const day = date.getDay();
                return date >= minDate && date <= maxDate && day !== 0 && day !== 6;
              }}
            />
          </div>
        </div>
        
        <div className="form-group" style={{ marginBottom: '15px' }}>
          <label>Freight arranged by:</label>
          <select defaultValue="" onChange={handleFreightChange} style={{ width: '100%', padding: '5px' }}>
            <option value=""></option>
            <option value="true">Duvel USA</option>
            <option value="false">Distributor arranges freight</option>
          </select>
        </div>
        
        <div style={{ marginBottom: '15px' }}>
          <strong>PLEASE NOTE</strong>
          <p>Please read <a href="#" style={{ color: 'white' }}>Duvel USA Terms of Sale</a> and <a href="#" style={{ color: 'white' }}>Duvel USA Shipping Guidelines</a></p>
        </div>
        
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <button type="button" style={{ width: '48%', padding: '10px', backgroundColor: '#a51a2d', color: 'white', border: 'none' }} onClick={onClose}>CANCEL</button>
          {!startingNewOrder && (
            <button type="submit"style={{ width: '48%', padding: '10px', backgroundColor: '#a51a2d', color: 'white', border: 'none', cursor: 'pointer' }} onClick={handleCreateNewOrder}>OK</button>
          )}
        </div>
      </>
    </div>
  );
};

export default NewOrder;